import React, { useState } from 'react';
import { SubscriptionDto, UpdateCreditBalanceUsageReq } from '../../../../interfaces';
import { centToUSD } from '../../../../utilities/common/commonFuntion';
import { useAuth } from '../../../../firebase/AuthProvider';
import { useAbortManager } from '../../../../hooks/cancelletionManagerHook/useAbortManager';
import { UpdateCreditBalanceUsageAsync } from '../../../../services/PaymentServices/SubscriptionService';
import { toast } from 'react-toastify';
import { getDisplayErrorMessage } from '../../../../utilities/ErrorMessages/getErrorMessage';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../Data/Routes/Routes';

interface CreditBalanceToggleProps {
    subscripton: SubscriptionDto;
    setSubscription: React.Dispatch<React.SetStateAction<SubscriptionDto | undefined>>;
}

const CreditBalanceToggle: React.FC<CreditBalanceToggleProps> = ({
    subscripton,
    setSubscription
}) => {
    const cancelletionManager = useAbortManager();
    const { currentUser } = useAuth();

    const [canUse, setCanUse] = useState(subscripton.canUseCreditBalance || false);
    const [loading, setLoading] = useState(false);

    const handleToggle = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.checked;
        setCanUse(newValue); // optimistic update
        setLoading(true);

        try {
            const token = await currentUser?.getIdToken();
            if (!token) return;

            var payload: UpdateCreditBalanceUsageReq = {
                canUseCreditBalance: newValue
            }
            const controller = cancelletionManager.create("updateCreaditbalence");
            var res = await UpdateCreditBalanceUsageAsync(token, payload, controller.signal);

            // on success, update subscription
            if (res.success) {
                setSubscription(prev => prev ? { ...prev, canUseCreditBalance: newValue } : prev);
            }

        } catch (error: any) {
            if (error.name === 'AbortError' || error.name === 'CanceledError') return;
            // revert on error
            setCanUse(!newValue);
            const msg = getDisplayErrorMessage(error, "Error to update.");
            toast.error(msg);
        } finally {
            setLoading(false);
            cancelletionManager.remove("updateCreaditbalence");
        }
    }

    return (
        <div className="usage-wrapper mt-2">
            <div className="auto-charge">
                <div>
                    <p className="auto-title">
                        Use credit balance for next billing{" "}
                        <Link to={ROUTES.ReferralPage()}>Go to referral page</Link>
                    </p>
                    <p className="auto-desc">
                        You have <strong>{centToUSD(subscripton.creditBalanceCents)}</strong> available.
                        Apply this to your next invoice automatically.
                    </p>
                </div>

                <label className="switch" title="Auto charge is managed by billing settings">
                    <input type="checkbox" checked={canUse} onChange={handleToggle} disabled={loading} />
                    <span className="slider"></span>
                </label>
            </div>

        </div>
    )
}

export default CreditBalanceToggle
